import React from "react";
import AccountLayout from "../layouts/AccountLayout/AccountLayout";
import CampaignsManagerContainer from "../features/campaigns/containers/CampaignsManagerContainer";

const CampaignsManagerView = (props) => {
  return (
    <AccountLayout>
      <CampaignsManagerContainer {...props} variant="campaigns" />
    </AccountLayout>
  );
};

export default CampaignsManagerView;
